import { useState, useEffect } from 'react';

export const useOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Mock data - replace with API call
    setTimeout(() => {
      setOrders([
        {
          id: '#1234',
          createdAt: new Date().toISOString(),
          customerName: 'John Doe',
          customerEmail: 'john@example.com',
          customerPhone: '+44 20 1234 5678',
          shippingAddress: '123 Street, London, UK',
          total: 349.99,
          status: 'processing',
          items: [
            { title: 'HD Security Camera', quantity: 2, price: 199.99 },
          ],
        },
      ]);
      setLoading(false);
    }, 500);
  }, []);

  const updateOrderStatus = async (orderId, status) => {
    setOrders((prev) =>
      prev.map((order) =>
        order.id === orderId ? { ...order, status } : order
      )
    );
  };

  return { orders, loading, updateOrderStatus };
};

